import React, { useState, useEffect } from 'react';
import api from '../api/client';

const styles = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f2f5' },
  card: { background: '#fff', borderRadius: 12, padding: '40px 36px', width: 380, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' },
  header: { background: '#2d4a8a', borderRadius: '12px 12px 0 0', margin: '-40px -36px 32px', padding: '24px 36px', textAlign: 'center' },
  title: { color: '#fff', fontSize: 18, fontWeight: 600 },
  frog: { fontSize: 40, display: 'block', marginBottom: 8 },
  tabs: { display: 'flex', marginBottom: 24, border: '1px solid #d0d8e8', borderRadius: 8, overflow: 'hidden' },
  tab: { flex: 1, padding: '9px 0', fontSize: 13, border: 'none', cursor: 'pointer', background: '#fff', color: '#666' },
  tabActive: { flex: 1, padding: '9px 0', fontSize: 13, border: 'none', cursor: 'pointer', background: '#2d4a8a', color: '#fff' },
  label: { fontSize: 13, color: '#666', marginBottom: 6, display: 'block' },
  input: { width: '100%', padding: '10px 12px', border: '1px solid #d0d8e8', borderRadius: 8, fontSize: 14, marginBottom: 14, outline: 'none', boxSizing: 'border-box' },
  btn: { width: '100%', padding: 13, background: '#2d4a8a', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 500, cursor: 'pointer' },
  btnDisabled: { width: '100%', padding: 13, background: '#aaa', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 500, cursor: 'not-allowed' },
  error: { color: '#e24b4a', fontSize: 13, marginBottom: 12, textAlign: 'center', background: '#fff5f5', padding: '8px', borderRadius: 6 },
  schoolCode: { fontSize: 12, color: '#888', textAlign: 'center', marginTop: 16 }
};

export default function LoginPage() {
  const [role, setRole] = useState('student');
  const [form, setForm] = useState({ grade: '', className: '', number: '', password: '', loginId: '', schoolCode: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setError('');
    setLoading(true);
    try {
      let res;
      if (role === 'student') {
        if (!form.schoolCode || !form.grade || !form.className || !form.number || !form.password) {
          setError('すべての項目を入力してください'); setLoading(false); return;
        }
        res = await api.post('/auth/student/login', {
          school_code: form.schoolCode,
          grade: parseInt(form.grade),
          class_name: form.className + '組',
          number: parseInt(form.number),
          password: form.password
        });
      } else if (role === 'teacher') {
        if (!form.loginId || !form.password) {
          setError('IDとパスワードを入力してください'); setLoading(false); return;
        }
        res = await api.post('/auth/teacher/login', { login_id: form.loginId, password: form.password });
      } else {
        if (!form.loginId || !form.password) {
          setError('IDとパスワードを入力してください'); setLoading(false); return;
        }
        res = await api.post('/auth/admin/login', { login_id: form.loginId, password: form.password });
      }
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('role', res.data.role);
      localStorage.setItem('userInfo', JSON.stringify(res.data));
      localStorage.removeItem('isDemo');
      window.location.href = '/' + res.data.role;
    } catch (e) {
      setError(e.response?.data?.error || 'ログインに失敗しました');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
          <span style={styles.frog}>🐸</span>
          <div style={styles.title}>ふりカエル</div>
          <div style={{ color: 'rgba(255,255,255,0.75)', fontSize: 13, marginTop: 4 }}>学習ふりかえりアプリ</div>
        </div>
        <div style={styles.tabs}>
          {['student','teacher','admin'].map(r => (
            <button key={r} style={role===r ? styles.tabActive : styles.tab} onClick={() => { setRole(r); setError(''); }}>
              {r==='student'?'児童・生徒':r==='teacher'?'教師':'管理者'}
            </button>
          ))}
        </div>
        {error && <div style={styles.error}>{error}</div>}
        {role === 'student' ? (
          <>
            <label style={styles.label}>学校コード</label>
            <input style={styles.input} placeholder="例：WAKU01" value={form.schoolCode} onChange={e=>setForm({...form,schoolCode:e.target.value.toUpperCase()})} />
            <div style={{fontSize:11,color:'rgba(255,255,255,0.7)',marginTop:-8,marginBottom:4}}>学校コードは先生に確認してください</div>
            <label style={styles.label}>学年</label>
            <input style={styles.input} type="number" placeholder="例：3" value={form.grade} onChange={e=>setForm({...form,grade:e.target.value})} />
            <label style={styles.label}>組</label>
            <input style={styles.input} type="number" placeholder="例：2" value={form.className} onChange={e=>setForm({...form,className:e.target.value})} />
            <label style={styles.label}>出席番号</label>
            <input style={styles.input} type="number" placeholder="例：15" value={form.number} onChange={e=>setForm({...form,number:e.target.value})} />
            <label style={styles.label}>パスワード</label>
            <input style={styles.input} type="text" value={form.password} onChange={e=>setForm({...form,password:e.target.value})}
              onKeyDown={e=>e.key==='Enter'&&handleSubmit()} />
          </>
        ) : (
          <>
            <label style={styles.label}>ログインID</label>
            <input style={styles.input} value={form.loginId} onChange={e=>setForm({...form,loginId:e.target.value})} />
            <label style={styles.label}>パスワード</label>
            <input style={styles.input} type="password" value={form.password} onChange={e=>setForm({...form,password:e.target.value})}
              onKeyDown={e=>e.key==='Enter'&&handleSubmit()} />
          </>
        )}
        <button style={loading ? styles.btnDisabled : styles.btn} onClick={handleSubmit} disabled={loading}>
          {loading ? 'ログイン中...' : 'ログイン'}
        </button>
        {role === 'student' && <div style={styles.schoolCode}>学校コードは先生に確認してください</div>}
      </div>
    </div>
  );
}
